import React from 'react';
import Dialog from '@mui/material/Dialog';
import LinearProgress from '@mui/material/LinearProgress';
import cs from 'classnames';

import styles from './Modal.module.scss';

type TModal = {
  children: React.ReactNode;
  open: boolean;
  onClose?: () => void;
  className?: string;
  hideBackdrop?: boolean;
  loading?: boolean;
  overflow?: string;
  mobileFullScreen?: boolean;
};

const Modal: React.FC<TModal> = ({ children, open, onClose, className, hideBackdrop, loading, overflow, mobileFullScreen }) => {
  return (
    <Dialog
      hideBackdrop={hideBackdrop}
      disableScrollLock
      maxWidth={false}
      className={cs(styles.modal, mobileFullScreen && styles.mobileFullScreen, className)}
      open={open}
      onClose={onClose}
      style={{ overflow }}
    >
      <div className={styles.modalContent}>
        {loading && <LinearProgress className={styles.loadingBar} />}
        {children}
      </div>
    </Dialog>
  );
};

export default Modal;
